import { useState, useEffect } from "react";
import { keyframes } from "@emotion/react";
import { Box, LinearProgress, linearProgressClasses } from "@mui/material";
const animateProgress = keyframes`
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
`;

const StyledLinearProgress = ({
  barcolor,
  ...props
}: {
  barcolor: string;
  [key: string]: any;
}) => {
  return (
    <LinearProgress
      sx={{
        height: 5,
        ...(!props?.overview && {
          borderRadius: 5,
        }),
        [`&.${linearProgressClasses.colorPrimary}`]: {
          backgroundColor: "grey.300",
        },
        [`& .${linearProgressClasses.bar}`]: {
          ...(!props?.overview && {
            borderRadius: 5,
          }),
          backgroundColor: barcolor || "#1a90ff",
          animation: `${animateProgress} 1s ease-out`,
        },
        ...(props?.overview && {
          height: "24px",
          maxWidth: "100px",
        }),
      }}
      {...props}
    />
  );
};

const CustomLinearProgress = ({
  value,
  color,
  overview = false,
}: {
  value: number;
  color: string;
  overview?: boolean;
}) => {
  const [animatedValue, setAnimatedValue] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimatedValue(value);
    }, 100);

    return () => clearTimeout(timer);
  }, [value]);

  return (
    <Box position="relative" width="100%">
      <StyledLinearProgress
        variant="determinate"
        value={animatedValue > 100 ? 100 : animatedValue}
        barcolor={color}
        overview={overview}
      />
    </Box>
  );
};

export default CustomLinearProgress;
